import { CompleteOperationType } from 'model/alerts.model';
import { useState } from 'react';
import { TaskService } from 'service/task.service';

interface UseTaskActionsProps {
  selectedData: any;
  setDrawerState: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleted: React.Dispatch<React.SetStateAction<string>>;
  completeOperation: CompleteOperationType;
}

export const useTaskActions = ({ setDeleted, completeOperation }: UseTaskActionsProps) => {
  const [loading, setLoading] = useState(false);

  const deleteTask = async (id: string) => {
    setLoading(true);
    try {
      await TaskService.deleteTask(id);
      setDeleted('removed');
    } catch (err) {
      completeOperation('delete', 'Task cannot be deleted', true);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    deleteTask,
  };
};
